import { util } from 'echarts/core';
import { VennMapDim, VennSeriesOption } from './type';
import {
  defaultOption,
  getVennMapName,
  UNIQUEKEY,
  VENN_DIM_MAX_EXTENT,
  VENN_DIM_MIN_EXTENT
} from './config';

function getDimensionCount(vennData: VennSeriesOption['data']): VennMapDim {
  if (vennData.length < VENN_DIM_MIN_EXTENT) {
    throw new Error('韦恩图的数据集合不能为空');
  } else if (vennData.length > VENN_DIM_MAX_EXTENT) {
    console.warn('韦恩图中超过7个的集合不会显示');
    return VENN_DIM_MAX_EXTENT;
  } else {
    return vennData.length as VennMapDim;
  }
}

export function parseDefaultOption(series: VennSeriesOption) {
  const dimensionCount = getDimensionCount(series.data);
  const computedAttrs: Pick<VennSeriesOption, 'dvDimensionCount' | 'map'> = {
    dvDimensionCount: dimensionCount,
    map: getVennMapName(dimensionCount)
  };
  // 计算属性和默认配置合并
  util.merge(computedAttrs, defaultOption);
  // 用户配置和计算属性合并
  util.merge(series, computedAttrs);

  // 图表数据与地图元素的关联属性
  // 内部强制定义为'name', 因为韦恩图确定通过name字段检索相关数据
  // see https://echarts.apache.org/zh/option.html#series-map.nameProperty
  series.nameProperty = UNIQUEKEY;
}
